/*! upsell.js — VÁZLAT, NEM TELEPÍTENDŐ (v1). Kosár-ajánló: a kosárban lévő telefon handle-jéhez a <base>/rec/<handle>.json ajánlatait rajzolja ki.
 * Kontroll-csoportban, kill switchnél, hibánál, hiányzó adatnál semmit nem mutat. Nincs naplózás/beacon: csak a saját JSON-ok és a Shopify /cart.js, /cart/update.js, /cart/add.js.
 * Mérés a rendelésből: a telefonos kosár `_ups_grp` attribútuma (c = kontroll, t = kezelt), az ajánlatból tett sor `_ups_src` tulajdonsága (szabály / auto).
 * textContent (nincs innerHTML), URL csak /products/…; a <base> alatt az export statikus fájljai (alap: a bolt gyökere).
 */
(function (root) {
  'use strict';

  var TEXT = { title: 'Recomandat pentru {telefon}', add: '+ Adaugă', rrp: 'Preț recomandat: {pret}', added: 'Adăugat ✓', currency: 'lei', error: 'Nu s-a putut adăuga',
    // a generikus fólia kártyacíme (owner 10-29 09:15): a kosárban lévő telefon modellje + színe, tárhely nélkül; horgony nélkül a rövid alak
    gfilm: 'Folie sticlă securizată premium', gfilmFor: 'Folie sticlă securizată premium pentru {telefon}', save: 'Economisești {suma}' };
  // HU (notebookgsm.hu): a garancia címe és feltétele magyarul (a warranty.json román szövege alapján — OWNER-JÓVÁHAGYÁSRA VÁR, ChatGPT-audit F03);
  // a román felület a warranty.json szövegét mutatja (változatlan)
  var TEXT_HU = { title: 'Ajánlott ehhez: {telefon}', rrp: 'Ajánlott ár: {pret}', add: '+ Kosárba', added: 'Kosárba téve ✓', error: 'Nem sikerült',
    wtitle: 'Kiterjesztett garancia +12 hónap',
    wterms: '+12 hónap kiterjesztett garancia hardverhibákra (az akkumulátorra nem vonatkozik); javítás 5 munkanapon belül, ingyenes elszállítás és visszaszállítás.',
    gfilm: 'Prémium edzett üvegfólia', gfilmFor: 'Prémium edzett üvegfólia – {telefon}', save: 'Megtakarítás: {suma}' };
  var SF_API = '/api/2025-07/graphql.json';                    // a bolt token nélküli Storefront API-ja (saját origin): a HU terméknév
  var PHONE_TYPE = 'Telefoane Mobile';
  var MAX_ITEMS = 4;
  // a generikus tartozék-termék (a motor classify „generic”-je, RO cím „Accesorii”) — a HU kosárban a VÁLTOZAT magyar neve, nem a termék gyűjtőneve
  var GENERIC = { accesorii: 1 };

  // --- holdout: ugyanaz, mint a Python holdout.assign_group: sha256("<só>:<token>") első 4 bájtja (big-endian) mod 10000
  function bucket(token, salt) {
    var data = new TextEncoder().encode(salt + ':' + token);
    return root.crypto.subtle.digest('SHA-256', data).then(function (buf) {
      return new DataView(buf).getUint32(0, false) % 10000;
    });
  }
  function assignGroup(token, pct, salt) {
    return bucket(token, salt).then(function (b) { return b < Math.round(pct * 100) ? 'control' : 'treatment'; });
  }

  // csak /products/<handle>[?variant=<szám>]: a handle nem tartalmazhat per-jelet, lekérdezést, és nem lehet „.” / „..”
  function safeUrl(u) { return typeof u === 'string' && /^\/products\/(?!\.+(?:\?|$))[^\s"'<>?#\/]+(?:\?variant=\d+)?$/.test(u) ? u : null; }

  // a csoport a Shopify kosár-tokenjéből jön (/cart.js `token`), nincs tárolt azonosító; token nélkül nincs besorolás → semmi.
  // Ragadósság: ez a blokk csak NEM üres kosárnál sorsol, ott a token már végleges → oldalról oldalra ugyanaz a csoport. Az üres kosár átmeneti
  // tokenje (minden /cart.js-re új, az első kosár-írásig) csak az xs / pdp felületet érinti — ott a kosáron tárolt t / c marad (stickyGroup, FOLLOWUP 10-28).
  function cartToken(cart) { return cart && typeof cart.token === 'string' && cart.token ? cart.token : null; }

  // kis termékkép: csak a Shopify CDN-ről, lekérdezés nélkül; a méretet mi adjuk (88 px, retina)
  function safeImg(u) { return typeof u === 'string' && /^https:\/\/cdn\.shopify\.com\/[^\s"'<>?#]+$/.test(u) ? u + '?width=176&height=176&crop=center' : null; }
  function fmt(n, cur) { return Number(n).toFixed(2).replace('.', ',') + ' ' + cur; }
  // a kosárban lévő telefon rövid neve a fejléchez („Telefon mobil Apple iPhone 17, 256GB” → „Apple iPhone 17”)
  function phoneName(phone) {
    var t = String((phone && (phone.product_title || phone.title)) || '').split(',')[0].replace(/^telefon mobil\s+/i, '').replace(/\s+-\s+.*$/, '').trim();
    return t.slice(0, 40);
  }
  // a generikus fólia címe — mint az upsell-pdp.js phoneModel / colorOf / filmTitle-je: a telefon modellje (gyártó az iPhone / Galaxy előtt, a hálózati /
  // SIM-farok és a HU „Mobiltelefon” nélkül) + a változat színe (a változatnév első tagja, a tárhely soha)
  function phoneModel(t) {
    return String(t || '').split(',')[0].replace(/^telefon mobil\s+/i, '').replace(/\s+-\s+.*$/, '').replace(/\s*\bmobiltelefon\b\s*/ig, ' ')
      .replace(/\b(?:5G|4G|LTE|Dual SIM)\b/gi, ' ').replace(/^(?:Apple|Samsung)\s+(?=(?:iPhone|Galaxy)\b)/i, '').replace(/\s+/g, ' ').trim().slice(0, 40);
  }
  function colorOf(vt) {
    var c = String(vt || '').split(' / ')[0].replace(/\s+-\s+open box$/i, '').trim();
    return !c || c === 'Default Title' || /^\d+\s*(?:GB|TB)$/i.test(c) ? '' : c;
  }
  function filmTitle(text, phoneTitle, vt) {
    var m = phoneModel(phoneTitle), c = colorOf(vt);
    return m ? String(text.gfilmFor).replace('{telefon}', (m + (c ? ' ' + c : '')).trim()) : text.gfilm;
  }
  function saveText(text, price, was) {
    var d = Math.round((Number(was) - Number(price)) * 100) / 100;
    return d > 0 ? String(text.save).replace('{suma}', (d % 1 === 0 ? String(d) : d.toFixed(2).replace('.', ',')) + ' ' + text.currency) : null;
  }
  function isGenFilm(it) { return !!(it && GENERIC[it.handle] && it.slot === 'film'); }

  var cache = {};
  function getJson(url) {
    if (!cache[url]) {
      var p = root.fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
      cache[url] = p;
      p.then(function (v) { if (v === null) delete cache[url]; }, function () { delete cache[url]; });      // csak a sikeres válasz marad meg: átmeneti hiba után a következő újrarajzolás újra próbál
      return p;
    }
    return cache[url];
  }

  // a kosár TELEFON-sora: az index.json `handles` listája dönt (nyelvfüggetlen: .hu → „Mobiltelefonok”);
  // több telefon esetén a legdrágább. Régebbi index (handles nélkül): tartalék a `product_type` szerint.
  function pickPhone(cart, handles) {
    var items = (cart && cart.items) || [], best = null, set = null;
    if (Array.isArray(handles)) { set = {}; handles.forEach(function (h) { set[h] = true; }); }
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.handle || !(set ? set[it.handle] : it.product_type === PHONE_TYPE)) continue;
      if (!best || Number(it.original_price || it.price || 0) > Number(best.original_price || best.price || 0)) best = it;
    }
    return best;
  }

  // a telefonos kosár csoportja a rendelésen (c = kontroll, t = kezelt); hibánál csendben tovább
  function markCart(cart, code) {
    if (cart && cart.attributes && cart.attributes._ups_grp === code) return Promise.resolve();
    return root.fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _ups_grp: code } })
    }).catch(function () { /* a jelölés nem kritikus */ });
  }

  // garancia-sáv: a kosárban lévő TELEFON-SOR listaára (lei, egészre levágva) dönt: lo <= ár <= hi
  function pickBand(w, phone) {
    if (!w || !Array.isArray(w.bands) || !phone) return null;
    var price = Math.floor(Number(phone.original_price != null ? phone.original_price : phone.price) / 100 + 1e-9);
    if (!isFinite(price)) return null;
    for (var i = 0; i < w.bands.length; i++) { var b = w.bands[i]; if (price >= b.lo && price <= b.hi && b.variant_id) return b; }
    return null;
  }

  function el(tag, cls, text) {
    var e = root.document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  var qa = false;                       // `?upsell_preview=1`: QA-nézet — a hozzáadott sor NEM kap `_ups_src`-t (a mérést nem szennyezi)

  // hozzáadás után a téma saját útján újrarajzolt kosár (sorok, összeg, fejléc-szám): fiókban `dispatch:cart-drawer:refresh`,
  // kosár-oldalon a <cart-items> refresh()-e; ismeretlen témánál a kosár-oldal újratöltődik
  function refreshCart(box) {
    var d = root.document;
    if (box && typeof box.closest === 'function' && box.closest('cart-drawer')) {
      d.dispatchEvent(new root.CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      return;
    }
    var items = typeof d.querySelector === 'function' ? d.querySelector('cart-items') : null;
    if (items && typeof items.refresh === 'function') items.refresh();
    else if (root.location && /\/cart\/?$/.test(root.location.pathname || '')) root.location.reload();
  }

  function addToCart(item, button, text, box) {
    button.disabled = true;
    var line = { id: item.variant_id, quantity: 1 };
    if (!qa) line.properties = { _ups_src: String(item.src || 'auto').slice(0, 40) };
    return root.fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [line] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      button.textContent = text.added;
      root.document.dispatchEvent(new root.CustomEvent('upsell:added', { detail: { variant_id: item.variant_id, slot: item.slot } }));
      try { refreshCart(box); } catch (e) { /* a téma frissítése nem kritikus: a tétel már a kosárban van */ }
    }).catch(function () { button.disabled = false; button.textContent = text.error; });
  }

  // ár + „Preț recomandat: X lei” (compare_at, ha nagyobb) egy dobozban: egy sorban, ha elfér, különben egészben alá
  function priceBox(price, was, text, strike) {
    var p = el('span', 'upsell-price');
    var on = was && Number(was) > Number(price);
    if (on && strike) p.appendChild(el('s', 'upsell-was', fmt(was, text.currency)));        // generikus fólia: áthúzott ár + megtakarítás (owner 10-29)
    p.appendChild(el('strong', 'upsell-now', fmt(price, text.currency)));
    if (on && strike) { var sv = saveText(text, price, was); if (sv) p.appendChild(el('span', 'upsell-save', sv)); }
    else if (on) p.appendChild(el('span', 'upsell-rrp', String(text.rrp).replace('{pret}', fmt(was, text.currency))));
    return p;
  }

  function addButton(item, text, box) {
    var b = el('button', 'upsell-add', text.add);
    b.type = 'button';
    b.addEventListener('click', function () { addToCart(item, b, text, box); });
    return b;
  }

  function render(box, rec, cart, text, band, warranty, phone) {
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (i) { inCart[i.variant_id] = true; });
    var shown = rec.items.filter(function (it) { return safeUrl(it.url) && it.variant_id && isFinite(Number(it.price)) && !inCart[it.variant_id]; }).slice(0, MAX_ITEMS);
    var wItem = band && !inCart[band.variant_id] && isFinite(Number(band.price)) ? { slot: 'warranty', variant_id: band.variant_id, title: text.wtitle || warranty.title || '', price: band.price, src: 'warranty' } : null;
    box.textContent = '';
    if (!shown.length && !wItem) { box.hidden = true; return; }       // nincs mit mutatni: a korábbi (elavult) tartalom sem maradhat látszani
    box.appendChild(el('h3', 'upsell-title', String(text.title).replace('{telefon}', phoneName(phone)).replace(/\s+$/, '')));
    var list = el('ul', 'upsell-list upsell-recs');                  // mobilon vízszintesen lapozható kártyasor (upsell-cart.liquid)
    shown.forEach(function (it) {
      var li = el('li', 'upsell-item upsell-' + String(it.slot).replace(/[^a-z]/g, ''));
      var href = safeUrl(it.url), src = safeImg(it.img);
      var thumb = el('a', 'upsell-thumb');
      thumb.href = href;
      if (src) {
        var im = el('img', 'upsell-img');
        im.addEventListener('error', function () {                    // a méretezett URL nem töltődött be → az eredeti, paraméter nélküli; ha az sem, nincs kép
          if (im.src.indexOf('?') > -1) im.src = im.src.split('?')[0]; else if (im.parentNode) im.parentNode.removeChild(im);
        });
        im.src = src; im.alt = ''; im.width = 88; im.height = 88; im.loading = 'lazy'; im.decoding = 'async';
        thumb.appendChild(im);
      }
      li.appendChild(thumb);
      var gf = isGenFilm(it), anchor = rec._anchor || {};
      var a = el('a', 'upsell-name', gf ? filmTitle(text, anchor.title || (phone && phone.product_title), anchor.vt || (phone && phone.variant_title)) : (it.name || it.title));
      a.href = href;
      li.appendChild(a);
      li.appendChild(priceBox(it.price, it.was, text, gf));
      li.appendChild(addButton(it, text, box));
      list.appendChild(li);
    });
    if (shown.length) box.appendChild(list);
    if (wItem) {                                                    // extra garancia: külön lista, kiemelt sor (pajzs), a sáv szerinti változat + 1 mondat a feltételről
      var wlist = el('ul', 'upsell-list upsell-wlist');
      var wl = el('li', 'upsell-item upsell-warranty');
      wl.appendChild(el('span', 'upsell-shield'));
      wl.appendChild(el('span', 'upsell-name', wItem.title));
      wl.appendChild(priceBox(wItem.price, null, text));
      wl.appendChild(addButton(wItem, text, box));
      if (text.wterms || warranty.terms) wl.appendChild(el('p', 'upsell-terms', text.wterms || warranty.terms));
      wlist.appendChild(wl);
      box.appendChild(wlist);
    }
    box.hidden = false;
  }

  // nincs mit mutatni (üres / telefon nélküli kosár, kontroll, kill switch, hiba): a régi ajánlat sem maradhat
  function hide(box) { box.textContent = ''; box.hidden = true; }

  var gen = 0;                          // futás-sorszám: a később visszaérő régi futás nem ír

  function main() {
    var box = root.document.getElementById('upsell-cart');
    if (!box || box.getAttribute('data-upsell')) return Promise.resolve();      // egy konténert csak egyszer dolgozunk fel
    box.setAttribute('data-upsell', '1');
    var my = ++gen;
    var off = function () { if (my === gen) hide(box); };
    var base = box.getAttribute('data-base') || '';
    var hu = /^hu/i.test((root.document.documentElement && root.document.documentElement.lang) || '');
    var text = Object.assign({}, TEXT, hu ? TEXT_HU : {}, root.UPSELL_TEXT || {});
    // előbb a (saját origin-ű) kosár: üres kosárnál nincs külső kérés; különben egy, 5 percig gyorsítótárazott index.json
    return root.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return off();
      return getJson(base + '/index.json').then(function (idx) {
        if (!idx || idx.v !== 1 || idx.kill_switch) return off();
        var phone = pickPhone(cart, idx.handles);
        if (!phone) return off();                                       // csak tartozék: semmi
        // QA: `?upsell_preview=1` megkerüli a kontroll-csoportot (a kosarat nem jelöli; a kill switch érvényes)
        var forced = /(?:^|[?&])upsell_preview=1(?:&|$)/.test((root.location && root.location.search) || '');
        qa = forced;
        var token = forced ? 'preview' : cartToken(cart);
        if (!token || !root.crypto || !root.crypto.subtle) return off();
        // hiányzó / hibás `holdout_pct` → kontroll (zárt hiba)
        var pct = idx.holdout_pct, pctOk = typeof pct === 'number' && isFinite(pct) && pct >= 0 && pct <= 100;
        var grouped = forced ? Promise.resolve('preview') : !pctOk ? Promise.resolve('control') : pct > 0 ? assignGroup(token, pct, idx.holdout_salt_id) : Promise.resolve('treatment');
        return grouped.then(function (group) {
          return (group === 'preview' ? Promise.resolve() : markCart(cart, group === 'treatment' ? 't' : 'c')).then(function () {
            if (group !== 'treatment' && group !== 'preview') return off();   // kontroll-csoport: semmit nem mutatunk
            return getJson(base + '/rec/' + encodeURIComponent(phone.handle) + '.json').then(function (rec) {
              if (!rec || rec.v !== 1 || rec.disabled || !Array.isArray(rec.items)) return off();
              var wp = rec.warranty && idx.warranty ? getJson(base + '/warranty.json').catch(function () { return null; }) : Promise.resolve(null);
              return wp.then(function (w) {
                var band = w && w.v === 1 ? pickBand(w, phone) : null;
                return (hu ? localNames(rec, phone) : Promise.resolve()).then(function () { if (my === gen) render(box, rec, cart, text, band, w, phone); });
              });
            });
          });
        });
      });
    }).catch(off);
  }

  // HU felületen a termék neve a bolt saját (fordított) neve a Storefront API-ból, a látogató országa / nyelve szerint; hibánál a motor (román) neve marad
  function localNames(rec, phone) {
    var s = root.Shopify || {}, ids = [], pv = phone && /^\d{1,20}$/.test(String(phone.variant_id)) ? String(phone.variant_id) : null;
    rec.items.forEach(function (it) { if (it && /^\d{1,20}$/.test(String(it.variant_id))) ids.push('gid://shopify/ProductVariant/' + it.variant_id); });
    rec._anchor = null;                                                                    // (a gyorsítótárazott rec egy korábbi telefon-változat színét ne vigye tovább)
    if (pv && rec.items.some(isGenFilm)) ids.push('gid://shopify/ProductVariant/' + pv);              // a generikus fólia címéhez: a telefon HU neve + színe
    var c = typeof s.country === 'string' && /^[A-Z]{2}$/.test(s.country) ? s.country : null;
    if (!ids.length) return Promise.resolve();
    var q = 'query X($ids:[ID!]!' + (c ? ',$c:CountryCode' : '') + ',$l:LanguageCode) @inContext(' + (c ? 'country:$c,' : '') + 'language:$l){nodes(ids:$ids){...on ProductVariant{id title product{title handle}}}}';
    var v = { ids: ids, l: 'HU' };
    if (c) v.c = c;
    return root.fetch(SF_API, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: q, variables: v }) })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        var names = {};
        (((d || {}).data || {}).nodes || []).forEach(function (n) {
          if (!n || !n.product || typeof n.product.title !== 'string') return;
          var vt = GENERIC[n.product.handle] && typeof n.title === 'string' && n.title.trim() && n.title !== 'Default Title' ? n.title : null;
          names[String(n.id).split('/').pop()] = vt || n.product.title;
          if (pv && String(n.id).split('/').pop() === pv) rec._anchor = { title: n.product.title, vt: n.title };
        });
        rec.items.forEach(function (it) { var t = names[String(it.variant_id)]; if (t) { t = t.replace(/\s+/g, ' ').trim(); it.name = t.length > 60 ? t.slice(0, 59).replace(/\s+$/, '') + '…' : t; } });
      }).catch(function () { /* a román név marad */ });
  }

  // a téma „Încarcă mai rapid!” sávja csak akkor rejtőzik, ha a mi blokkunk látszik (<html data-upsell-shown>, upsell-cart.liquid)
  function syncShown() {
    var d = root.document, b = d && d.getElementById('upsell-cart'), root_el = d && d.documentElement;
    if (!root_el || typeof root_el.setAttribute !== 'function') return;
    if (b && !b.hidden && b.children && b.children.length) root_el.setAttribute('data-upsell-shown', '1'); else root_el.removeAttribute('data-upsell-shown');
  }

  function start() { main().then(syncShown, function () { syncShown(); /* hiba esetén nincs ajánlat */ }); }

  // böngésző-üresjáratban indul (requestIdleCallback), különben rövid késleltetéssel
  function later(fn) {
    if (typeof root.requestIdleCallback === 'function') root.requestIdleCallback(fn, { timeout: 2000 });
    else root.setTimeout(fn, root.UPSELL_DELAY_MS != null ? root.UPSELL_DELAY_MS : 800);
  }

  // a téma újrarajzolhatja a fiókot (új #upsell-cart): az új, feldolgozatlan konténert újra kitöltjük
  function watch() {
    if (typeof root.MutationObserver !== 'function' || !root.document.body) return;
    var timer = null;
    new root.MutationObserver(function () {
      if (timer) return;
      timer = root.setTimeout(function () {
        timer = null;
        var b = root.document.getElementById('upsell-cart');
        if (b && !b.getAttribute('data-upsell')) start();
      }, 400);
    }).observe(root.document.body, { childList: true, subtree: true });
  }

  if (root.document) {
    var boot = function () { later(start); watch(); };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot); else boot();
    root.document.addEventListener('upsell:refresh', function () {
      cache = {};
      var b = root.document.getElementById('upsell-cart');
      if (b) b.removeAttribute('data-upsell');
      start();
    });
    // a téma kosár-eseményei (fiók + kosár-oldal): a téma csak a sorokat rajzolja újra, a dobozt nem → újraszámolás; üres kosárnál azonnal el
    var onCartChange = function (e) {
      var b = root.document.getElementById('upsell-cart'), c = e && e.detail && e.detail.cart;
      if (!b) return;
      if (c && c.item_count === 0) { gen++; hide(b); syncShown(); }
      b.removeAttribute('data-upsell');
      start();
    };
    root.document.addEventListener('on:line-item:change', onCartChange);
    root.document.addEventListener('on:cart:add', onCartChange);
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { assignGroup: assignGroup, bucket: bucket, safeUrl: safeUrl, pickPhone: pickPhone, pickBand: pickBand,
    phoneModel: phoneModel, colorOf: colorOf, filmTitle: filmTitle, saveText: saveText, TEXT: TEXT, TEXT_HU: TEXT_HU }; }
})(typeof window !== 'undefined' ? window : globalThis);
